import Vue from 'vue'
import gql from 'graphql-tag'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { Insured } from '@/modules/Insured/interfaces/insured'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import InsuredForm from '@/modules/Insured/components/InsuredForm.vue'
import { deleteInsured } from '@/modules/Insured/gql/insured.gql'

@Component({
  components: {
    InsuredForm,
    AppDialog
  }
})
export default class InsuredDialog extends Vue {
  targetInsured: Insured | null = null

  insuredDialog = {
    actionType: 'new',
    show: false,
    title: 'New Insured',
    disable: false
  }

  deleteInsuredDialog = {
    show: false,
    title: 'Delete Insured',
    text: ''
  }

  showInsuredEditDialog (e: Event, targetInsured?: Insured) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Insured'
    if (targetInsured) {
      this.targetInsured = targetInsured
      actionType = 'edit'
      title = 'Edit Insured'
    }
    this.insuredDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hideInsuredEditDialog () {
    this.targetInsured = null
    this.insuredDialog = {
      actionType: 'new',
      show: false,
      title: 'New Insured',
      disable: false
    }
  }

  async deleteInsured (e: Event, insured: Insured) {
    e.preventDefault()
    e.stopPropagation()
    this.targetInsured = insured
    this.deleteInsuredDialog.show = true
  }

  async deleteInsuredPost () {
    if (!this.targetInsured) {
      return
    }
    const { id } = this.targetInsured
    this.deleteInsuredDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteInsured,
        variables: {
          insuredId: Number(id)
        }
      })

      const res = result.data.deleteInsured
      if (res) {
        showNotification({
          msg: 'Delete insured successfully',
          type: SnackType.Success
        })
        this.targetInsured = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
